import { createSelector } from 'reselect'

const getBanners = state => state.banners

export const getBannersList = createSelector(getBanners, banners =>
  Object.values(banners),
)
